theme.HeaderSection = new (function () {
  this.onSectionLoad = function (container) {
    // block focus events targeted at the social icons
    $(container).on(
      "focusin.headerSection focusout.headerSection",
      ".social-links",
      function (e) {
        return false;
      }
    );

    // asses focus, and handle transitioning between child elements with a timeout
    var searchFocusOutTimeoutId = -1;
    $(container).on(
      "focusin.headerSection focusout.headerSection",
      ".search-box",
      function (e) {
        if (e.type == "focusin") {
          clearTimeout(searchFocusOutTimeoutId);
          $(this).closest(".search-box").addClass("focus");
        } else {
          clearTimeout(searchFocusOutTimeoutId);
          searchFocusOutTimeoutId = setTimeout(
            function () {
              $(this).closest(".search-box").removeClass("focus");
            }.bind(this),
            200
          );
        }
      }
    );

    // Toggle search
    $(container).on(
      "click.headerSection",
      ".show-search-link",
      function (e) {
        if ($("body").toggleClass("show-search").hasClass("show-search")) {
          setTimeout(function () {
            $(".main-search__input:first").focus();
          }, 500);
          $(".main-search__suggestions .lazyload--manual")
            .removeClass("lazyload--manual")
            .addClass("lazyload");
        } else {
          $(".show-search-link:first").focus();
        }
        return false;
      }
    );

    // Close search on escape
    $(container).on("keyup.headerSection", ".main-search__input", function (e) {
      if (e.keyCode == 27) {
        $(".main-search__close").click();
      }
    });

    //Close button search
    $(container).on("click",".main-search__close", function(e){
      var $searchContainer = $(".main-search");
            $resultsBox = $searchContainer.find(".main-search__results");
      $searchContainer.removeClass("main-search--has-results main-search--results-on-multiple-lines main-search--loading");
            $resultsBox.empty();
    })
    /// Live search
    var $liveSearchContainer = $(
      '.main-search[data-live-search="true"]',
      container
    );
    if ($liveSearchContainer.length) {
      var searchTimeoutThrottle = 500,
        searchTimeoutID = -1,
        currReqObj = null,
        resultLimit = 8,
        showPrice = $liveSearchContainer.data("live-search-price"),
        showVendor = $liveSearchContainer.data("live-search-vendor"),
        includeMeta = $liveSearchContainer.data("live-search-meta"),
        perRowMob = $liveSearchContainer.data("per-row-mob");

      $(container).on(
        "keyup.headerSection change.headerSection",
        ".main-search__input",
        function () {
          var $searchContainer = $(".main-search"),
            $resultsBox = $searchContainer.find(".main-search__results"),
            valueToSearch = $(this).val();

          //Only search if search string longer than 2, and it has changed
          if (
            valueToSearch.length > 2 &&
            valueToSearch != $(this).data("oldval")
          ) {
            //Reset previous value
            $(this).data("oldval", valueToSearch);

            // Kill outstanding ajax request
            if (currReqObj != null) {
              currReqObj.abort();
            }

            // Kill previous search
            clearTimeout(searchTimeoutID);

            // Create URL for full search results
            var $form = $(this).closest("form");
            var linkURL =
              $form.attr("action") +
              ($form.attr("action").indexOf("?") > -1 ? "&" : "?") +
              $form.serialize();

            //Show loading
            $searchContainer
              .removeClass(
                "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
              )
              .addClass("main-search--loading");
            if ($(".main-search__results-spinner").length === 0) {
              $resultsBox.html(
                '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>'
              );
            }

            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function () {
              var ajaxUrl, ajaxData;
              if (theme.Shopify.features.predictiveSearch) {
                // use the API
                ajaxUrl = theme.routes.predictive_search_url;
                ajaxData = {
                  q: valueToSearch,
                  section_id: "predictive-search",
                  resources: {
                    type: $form.find('input[name="type"]').val(),
                    limit: resultLimit,
                    options: {
                      unavailable_products: "last",
                      fields: includeMeta
                        ? "title,product_type,variants.title,vendor,tag,variants.sku"
                        : "title,product_type,variants.title,vendor",
                    },
                  },
                };
              } else {
                // use the theme template fallback
                ajaxUrl = linkURL;
                ajaxData = {
                  section_id: "main-search",
                };
              }
              //Ajax hit on search page
              currReqObj = $.ajax({
                url: ajaxUrl,
                data: ajaxData,
                dataType: "html",
                success: function success(response) {
                  var $resultsList = null;
                  if (!theme.Shopify.features.predictiveSearch) {
                    $resultsList = $("<div>" + response + "</div>").find(
                      '[data-section-type="search-template"] .product-list'
                    );
                  } else {
                    $resultsList = $(response).find(".product-list");
                  }

                  // reset previous contents
                  currReqObj = null;
                  theme.ProductBlockManager.unloadImages($resultsBox);
                  $searchContainer.removeClass(
                    "main-search--has-results main-search--results-on-multiple-lines main-search--no-results"
                  );
                  $resultsBox.empty();
                  //show close btn
                  var closeBtn = '<button class="main-search__close button notabutton" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>';
                  $resultsBox.append(closeBtn);
                  
                  var $resultsProducts = $(
                    '<div class="main-search__results__products collection-listing"><div></div></div>'
                  );
                  var $resultsPages = $(
                    '<div class="main-search__results__pages">'
                  );

                  $resultsProducts.children()[0].className =
                    $resultsList[0].className;

                  $resultsList
                    .find(
                      ".product-block:not(.collection-block):not(.page-block)"
                    )
                    .slice(0, resultLimit)
                    .addClass("main-search-result")
                    .each(function () {
                      $(this).find(".btn.quickbuy-toggle").remove();
                      $(this)
                        .find(".quickbuy-toggle")
                        .removeClass("quickbuy-toggle");
                      if (!showPrice) {
                        $(this).find(".product-price").remove();
                      }
                      if (!showVendor) {
                        $(this).find(".vendor").remove();
                      }
                    })
                    .appendTo($resultsProducts.children());

                  $resultsList
                    .find(".product-block.page-block")
                    .each(function () {
                      var $item = $(
                        '<a class="main-search-result main-search-result--page">'
                      ).attr("href", $(this).find("a:first").attr("href"));
                      $('<div class="main-search-result__text">')
                        .text($(this).find(".page-block__title").text())
                        .appendTo($item);
                      $resultsPages.append($item);
                    });

                  $searchContainer.removeClass("main-search--loading");

                  var areProducts =
                      $resultsProducts.find(".main-search-result:first")
                        .length > 0,
                    arePages =
                      $resultsPages.find(".main-search-result:first").length >
                      0;
                  if (areProducts || arePages) {
                    // Numerous results
                    $searchContainer.addClass("main-search--has-results");
                    $searchContainer.toggleClass(
                      "main-search--results-on-multiple-lines",
                      $resultsProducts.find(".product-block").length > 4
                    );
                    if (areProducts) {
                      $resultsBox.append($resultsProducts);
                      theme.ProductBlockManager.loadImages($resultsProducts);
                    }
                    if (arePages) {
                      $('<h6 class="main-search-result__heading">')
                        .html(theme.strings.general_quick_search_pages)
                        .prependTo($resultsPages);
                      $resultsBox.append($resultsPages);
                    }
                    $(
                      '<a class="main-search__results-all-link button altcolour">'
                    )
                      .attr("href", linkURL)
                      .html(theme.strings.layout_live_search_see_all)
                      .appendTo($resultsBox);

                    theme.initAnimateOnScroll();
                  } else {
                    // No results - show nothing
                    $searchContainer.addClass("main-search--no-results");
                    $('<div class="main-search__empty-message">')
                      .html(theme.strings.general_quick_search_no_results)
                      .appendTo($resultsBox);
                  }
                  
                },
                error: function error(response) {
                  console.log("Error fetching results");
                },
              });
            }, searchTimeoutThrottle);
          } else if ($(this).val().length <= 2) {
            // Deleted text? Abandon search-in-progress
            $(this).data("oldval", valueToSearch);
            if (currReqObj != null) {
              currReqObj.abort();
            }
            clearTimeout(searchTimeoutID);

            // Clear results
            $searchContainer.removeClass(
              "main-search--has-results main-search--results-on-multiple-lines main-search--loading"
            );
            $resultsBox.empty();
          }
        }
      );
    }

    // nav
    theme.Navigation.init({
      nav: $(".navigation--main", container),
      mobileNavHtml: $(".mobile-navigation-drawer-template", container).html(),
      proxyTier1Nav: $(".navigation--left", container),
    });

    if (theme.inlineNavigationCheck) {
      theme.inlineNavigationCheck();
      $(window).on(
        "debouncedresize.headerSection",
        theme.inlineNavigationCheck
      );
    } else if (document.querySelector("#InlineNavigationCheckScript")) {
      // if just enabled in theme editor but not evaluated
      eval(document.querySelector("#InlineNavigationCheckScript").innerHTML);
    }

    // set anything that alters based on contents/viewport/scroll, etc
    this.section = document.querySelector(".section-header");
    this.transparentPageheader = document.querySelector(
      ".pageheader--transparent-permitted"
    );

    this.functions.setTransparency.call(this);
    this.functions.setSticky.call(this);
    this.functions.setHeaderHeightProperty.call(this);

    $(window).on("scroll.headerSection", this.functions.afterScroll.bind(this));
    $(window).on(
      "debouncedresize.headerSection",
      this.functions.afterResize.bind(this)
    );

    // account / localization (after mobile nav initialises)
    $(".disclosure", container).each(function () {
      $(this).data("disclosure", new theme.Disclosure($(this)));
    });

    $(".mobile-navigation-drawer .disclosure").each(function () {
      $(this).data("disclosure", new theme.Disclosure($(this)));
    });

    // listen to cart changes
    $(document).on("theme:cartchanged.headerSection", function () {
      $.getJSON(location.origin + "?sections=header", function (data) {
        var cartSummarySelectors = ["#pageheader .logo-area__right__inner"];
        for (var i = 0; i < cartSummarySelectors.length; i++) {
          var $newCartObj = $("<div>" + data.header + "</div>")
            .find(cartSummarySelectors[i])
            .first();
          var $currCart = $(cartSummarySelectors[i]);
          $currCart.html($newCartObj.html());
        }
      });
    });

    // init mobile nav again if it's open and this is a reload
    if (Shopify.designMode && $("body").hasClass("reveal-mobile-nav")) {
      theme.openMobileNav();
    }
  };

  this.onSectionUnload = function (container) {
    $(container).off(".headerSection");
    $(document).off(".headerSection");
    $(window).off(".headerSection");
    $(".disclosure", container).each(function () {
      $(this).data("disclosure").unload();
    });
    $(".mobile-navigation-drawer .disclosure").each(function () {
      $(this).data("disclosure").unload();
    });
    theme.Navigation.destroy(
      $(".navigation", container),
      $(".navigation--left", container)
    );
  };

  this.functions = {
    afterScroll: function afterScroll() {
      this.functions.setTransparency.call(this);
    },

    afterResize: function afterResize() {
      this.functions.setSticky.call(this);
      this.functions.setHeaderHeightProperty.call(this);
    },

    setTransparency: function setTransparency() {
      if (this.transparentPageheader) {
        var bar = document.querySelector(".section-announcement-bar"),
          scrollThreshold = bar ? bar.offsetTop + bar.clientHeight : 0;
        if (!this.isSticky || window.scrollY <= scrollThreshold) {
          this.transparentPageheader.classList.add("pageheader--transparent");
        } else {
          this.transparentPageheader.classList.remove(
            "pageheader--transparent"
          );
        }
      }
    },

    setSticky: function setSticky() {
      this.isSticky =
        getComputedStyle(this.section).position === "sticky" ||
        getComputedStyle(this.section).position === "-webkit-sticky";
    },

    setHeaderHeightProperty: function setHeaderHeightProperty() {
      var headerHeight = 0,
        stickyHeaderHeight = 0;
      if (this.section) {
        headerHeight = Math.ceil(this.section.clientHeight);
        if (this.isSticky) {
          stickyHeaderHeight = headerHeight;
        }
      }
      document.documentElement.style.setProperty(
        "--theme-header-height",
        headerHeight + "px"
      );
      document.documentElement.style.setProperty(
        "--theme-sticky-header-height",
        stickyHeaderHeight + "px"
      );
    },
  };
})();


theme.AnnouncementBarSection = new (function () {
  this.onSectionLoad = function (container) {
    this.container = container;
    $(".disclosure", container).each(function () {
      $(this).data("disclosure", new theme.Disclosure($(this)));
    });

    this.announcements = container.querySelectorAll(".announcement");
    if (this.announcements.length > 1) {
      this.currentAnnouncement = 0;
      container
        .querySelector(".announcement-bar__middle")
        .addEventListener(
          "focusin",
          this.functions.pauseAnnouncements.bind(this)
        );
      container
        .querySelector(".announcement-bar__middle")
        .addEventListener(
          "focusout",
          this.functions.playAnnouncements.bind(this)
        );
      container
        .querySelector(".announcement-button--previous")
        .addEventListener(
          "click",
          this.functions.previousAnnouncement.bind(this)
        );
      container
        .querySelector(".announcement-button--next")
        .addEventListener("click", this.functions.nextAnnouncement.bind(this));
      this.observer = new IntersectionObserver(
        this.functions.handleIntersect.bind(this)
      );
      this.observer.observe(this.container);
    }
  };

  this.functions = {
    handleIntersect: function handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.target == this.container) {
          if (entry.isIntersecting) {
            this.functions.playAnnouncements.call(this);
          } else {
            this.functions.pauseAnnouncements.call(this);
          }
        }
      });
    },

    playAnnouncements: function playAnnouncements() {
      this.announcementInterval = setInterval(() => {
        this.functions.setCurrentAnnouncement.call(
          this,
          this.currentAnnouncement + 1
        );
      }, 5000);
    },

    pauseAnnouncements: function pauseAnnouncements() {
      if (this.announcementInterval) {
        clearInterval(this.announcementInterval);
      }
    },

    setCurrentAnnouncement: function setCurrentAnnouncement(newIndex) {
      this.currentAnnouncement = newIndex % this.announcements.length;
      this.announcements.forEach((el, index) => {
        if (index !== this.currentAnnouncement) {
          el.classList.add("announcement--inactive");
        } else {
          el.classList.remove("announcement--inactive");
        }
      });
    },

    previousAnnouncement: function previousAnnouncement() {
      this.functions.setCurrentAnnouncement.call(
        this,
        this.currentAnnouncement - 1
      );
    },

    nextAnnouncement: function nextAnnouncement() {
      this.functions.setCurrentAnnouncement.call(
        this,
        this.currentAnnouncement + 1
      );
    },
  };

  this.onSectionUnload = function (container) {
    clearInterval(this.announcementInterval);

    $(".disclosure", container).each(function () {
      $(this).data("disclosure").unload();
    });

    if (this.observer) {
      this.observer.disconnect();
    }
  };

  this.onBlockSelect = function (block) {
    var index = Array.prototype.indexOf.call(
      block.parentElement.children,
      block
    );
    this.functions.pauseAnnouncements.call(this);
    this.functions.setCurrentAnnouncement.call(this, index);
  };

  this.onBlockDeselect = function (block) {
    this.functions.playAnnouncements.call(this);
  };
})();


theme.Sections.register("header", theme.HeaderSection, {
  deferredLoad: false,
});
theme.Sections.register("announcement-bar", theme.AnnouncementBarSection, {
  deferredLoad: false,
});
